import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTShirt$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTShirt extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '9a2fcfde06b751465682490a866050dfd7346647', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e0dd81b77d93b5c1c6ea9a44fd8528cff0918369', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '5276d1e9b4096440e685de6ea9952bcf0b9151f7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m14.516 6.107 3.76 1.457-.833 2.775-2.805-.797a.5.5 0 0 0-.638.481V15.5H8v-5.477a.5.5 0 0 0-.638-.48l-2.805.797-.832-2.776 3.758-1.456A7.8 7.8 0 0 0 11 6.85a7.8 7.8 0 0 0 3.516-.743m-.103-1.605a.6.6 0 0 0-.34.128A5.9 5.9 0 0 1 11 5.35a5.9 5.9 0 0 1-3.073-.72.67.67 0 0 0-.351-.125.7.7 0 0 0-.25.055l-4.905 1.9c-.38.15-.49.35-.38.71l1.331 4.44q.142.45.517.451a.8.8 0 0 0 .214-.031l2.397-.68v5.15a.495.495 0 0 0 .5.5h8a.495.495 0 0 0 .5-.5v-5.15l2.398.68a.8.8 0 0 0 .221.035c.25 0 .423-.156.51-.455l1.331-4.44c.11-.36 0-.56-.38-.71l-4.905-1.9a.8.8 0 0 0-.26-.058z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-t-shirt", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-t-shirt"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-t-shirt":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTShirt$1);
            }
            break;
    } });
}

const CosmosIconTShirt = CosmosIconTShirt$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTShirt, defineCustomElement };
